import React, { useId } from 'react';
import { usePos } from '../../pages/POS/PosContext';

export function CustomerFields({ forceShow }: { forceShow?: boolean }) {
  const { isTakeawayMode, orderCustomer, setOrderCustomer } = usePos();
  const nameId = useId();
  const phoneId = useId();
  const addressId = useId();

  if (!isTakeawayMode && !forceShow) {
    return null;
  }

  return (
    <div className="mt-3 space-y-3" aria-live="polite">
      <div className="flex flex-col gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted" htmlFor={nameId}>
          Nombre del cliente
        </label>
        <input
          id={nameId}
          type="text"
          className="w-full rounded-xl border border-divider bg-surface px-3 py-2 text-sm text-[color:var(--text)] placeholder:text-slate-400 focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/10 focus:border-[color:var(--primary)] transition-all duration-300 shadow-sm"
          placeholder="Ej. Ana Pérez"
          value={orderCustomer.customerName}
          onChange={(event) => setOrderCustomer(prev => ({ ...prev, customerName: event.target.value }))}
          aria-describedby={`${nameId}-hint`}
        />
        <span id={`${nameId}-hint`} className="text-[11px] text-muted">
          Se mostrará en cocina junto al pedido.
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted" htmlFor={phoneId}>
          Teléfono (opcional)
        </label>
        <input
          id={phoneId}
          type="tel"
          className="w-full rounded-xl border border-divider bg-surface px-3 py-2 text-sm text-[color:var(--text)] placeholder:text-slate-400 focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/10 focus:border-[color:var(--primary)] transition-all duration-300 shadow-sm"
          placeholder="Ej. 555-1234"
          value={orderCustomer.customerPhone}
          onChange={(event) => setOrderCustomer(prev => ({ ...prev, customerPhone: event.target.value }))}
        />
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-xs font-semibold uppercase tracking-wide text-muted" htmlFor={addressId}>
          Dirección (opcional)
        </label>
        <input
          id={addressId}
          type="text"
          className="w-full rounded-xl border border-divider bg-surface px-3 py-2 text-sm text-[color:var(--text)] placeholder:text-slate-400 focus:outline-none focus:ring-4 focus:ring-[color:var(--primary)]/10 focus:border-[color:var(--primary)] transition-all duration-300 shadow-sm"
          placeholder="Ej. Calle 123 #45-67"
          value={orderCustomer.customerAddress || ''}
          onChange={(event) => setOrderCustomer(prev => ({ ...prev, customerAddress: event.target.value }))}
        />
      </div>
    </div>
  );
}
